var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center text-muted p-3"},[(_vm.fields.link)?_c('prismic-link',{attrs:{"field":_vm.fields.link}},[_c('prismic-rich-text',{attrs:{"field":_vm.fields.copyright}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }